<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>

<template>
  <div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('shujuhuizong') }}
        </p>
      </div>
    </div>

    <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
      <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
        <div>
          <img style="width: 140px;height: auto;" :src="require('../../../../assets/img/web/energy/energy' + 1 + '.png')" />
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('zuorizongyongdianliang') }}</p>
          <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
            {{ cockpitData.sum.yesterdayTotalEle }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
          </p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('jiaoguoqusanshitianrijunyongdian') }}</p>
          <div style="display: flex;align-items: center;justify-content: center;">
            <img v-if="cockpitData.sum.thanThirtyDayAverageEle >= 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/up.png" />
            <img v-if="cockpitData.sum.thanThirtyDayAverageEle < 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/down.png" />
            <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.thanThirtyDayAverageEle }}%
            </p>
          </div>
        </div>
      </div>
      <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
        <div>
          <img style="width: 140px;height: auto;" :src="require('../../../../assets/img/web/energy/energy' + 2 + '.png')" />
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('dangyueyongdianzongliang') }}</p>
          <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
            {{ cockpitData.sum.theMonthTotalEle }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
          </p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('jiaoshangyuetongqiyongdian') }}</p>
          <div style="display: flex;align-items: center;justify-content: center;">
            <img v-if="cockpitData.sum.thanLastMonthSameDateEle >= 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/up.png" />
            <img v-if="cockpitData.sum.thanLastMonthSameDateEle < 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/down.png" />
            <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.thanLastMonthSameDateEle }}%
            </p>
          </div>
        </div>
      </div>
      <div v-if="cockpitData.sum" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;align-items: center;" :style="{ height: chartHeight - 20 + 'px' }">
        <div>
          <img style="width: 140px;height: auto;" :src="require('../../../../assets/img/web/energy/energy' + 3 + '.png')" />
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('jinnianzongyongdianliang') }}</p>
          <p style="font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
            {{ cockpitData.sum.theYearTotalEle }}<span style="font-size: 14px;color: #999999;">{{ $t('kwh') }}</span>
          </p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14px;color: #999999;">{{ $t('jiaoquniantongqiyongdian') }}</p>
          <div style="display: flex;align-items: center;justify-content: center;">
            <img v-if="cockpitData.sum.thanLastYearSameDateEle >= 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/up.png" />
            <img v-if="cockpitData.sum.thanLastYearSameDateEle < 0" style="width: 52px;height: auto;" src="../../../../assets/img/web/energy/down.png" />

            <p style="margin-left: 10px;font-size: 22px;font-weight: bold;color: rgb(255,189,65);">
              {{ cockpitData.sum.thanLastYearSameDateEle }}%
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_energy_sum',
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      timer: null,
      chartHeight: 0
    };
  },
  created() { },

  watch: {
    cockpitData(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.makeChart();
    }
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    makeChart() { },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
      }, 800);
    }
  }
};
</script>
